// ============================================================================
// note-client-mod -- useNotes Hook
//
// 获取当前用户的笔记列表，支持笔记本过滤、标签过滤、关键字搜索、分页、排序、
// 归档/收藏过滤。所有过滤项均可动态更新（面板切换入口/搜索时即时生效）。
// 支持 SSR：传入 initialData 则首次渲染直接使用（不请求）。
// ============================================================================
import { useState, useEffect, useCallback, useRef } from 'react';
import { getNoteApiClient } from '../note-api-client.js';
export function useNotes(params) {
    const pageSize = params?.pageSize ?? 10;
    const initialData = params?.initialData;
    const [notes, setNotes] = useState(initialData?.data ?? []);
    const [pagination, setPagination] = useState(initialData?.pagination ?? null);
    const [loading, setLoading] = useState(!initialData);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [notebookId, setNotebookId] = useState(undefined);
    const [keyword, setKeyword] = useState(undefined);
    const [tag, setTag] = useState(undefined);
    const [isArchived, setArchived] = useState(undefined);
    const [isFavorite, setFavorite] = useState(undefined);
    const [sortBy, setSortBy] = useState(undefined);
    const [sortOrder, setSortOrder] = useState(undefined);
    const isFirstRender = useRef(true);
    const fetchNotes = useCallback(async () => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            if (initialData)
                return;
        }
        setLoading(true);
        setError(null);
        try {
            const query = {
                page,
                pageSize,
                notebookId,
                keyword,
                tag,
                isArchived,
                isFavorite,
                sortBy,
                sortOrder,
            };
            const result = await getNoteApiClient().getNotes(query);
            setNotes(result.data);
            setPagination(result.pagination);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '获取笔记失败';
            setError(message);
            setNotes([]);
            setPagination(null);
        }
        finally {
            setLoading(false);
        }
    }, [page, pageSize, notebookId, keyword, tag, isArchived, isFavorite, sortBy, sortOrder, initialData]);
    useEffect(() => {
        fetchNotes();
    }, [fetchNotes]);
    return {
        notes,
        pagination,
        loading,
        error,
        refresh: fetchNotes,
        setPage,
        setNotebookId,
        setKeyword,
        setTag,
        setArchived,
        setFavorite,
        setSortBy,
        setSortOrder,
    };
}
//# sourceMappingURL=use-notes.js.map